import { Injectable } from '@angular/core';

@Injectable()
export class PaginationService {
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 8) {
        // calculate total pages
        const totalPages = Math.ceil(totalItems / pageSize);

        // ensure current page isn't out of range
        if (currentPage < 1) {
            currentPage = 1;
        } else if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        const pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    sortArray(array: any[], objKey: string, reverse: boolean): any[] {
        if (!reverse) {
            array.sort((a, b) => (a[objKey].toLowerCase() > b[objKey].toLowerCase()) ? 1
                : ((b[objKey].toLowerCase() > a[objKey].toLowerCase()) ? -1 : 0));
        } else {
            array.sort((a, b) => (a[objKey].toLowerCase() > b[objKey].toLowerCase()) ? -1
                : ((b[objKey].toLowerCase() > a[objKey].toLowerCase()) ? 1 : 0));
        }

        return array;
    }

    filterArray(array: any[], objKey: string, words: string[]): any[] {
        if (words.length === 0) {
            words = [''];
        }

        return array.filter((element) => {
            let isValid = false;

            for (const word of words) {
                if (element[objKey].toString().toLowerCase().includes(word.toLocaleLowerCase())) {
                    isValid = true;
                }
            }

            return isValid;
        });
    }

    filterArrayComplex(array: any[], words: string[]): any[] {
        if (words.length === 0) {
            words = [''];
        }

        return array.filter((element) => {
            let isValid = false;
            for (const word of words) {
                if (element.FullName.toString().toLowerCase().includes(word.toLocaleLowerCase()) ||
                    element.Phone.toString().toLowerCase().includes(word.toLocaleLowerCase()) ||
                    element.Email.toString().toLowerCase().includes(word.toLocaleLowerCase())
                ) {
                    isValid = true;
                }
            }

            return isValid;
        });
    }
}
